import { useCallback, useContext, useMemo } from 'react';
import {
  ModalContext,
  createModal as createModalAction,
  createUnshiftModal as createUnshiftModalAction,
  deleteModal as deleteModalAction,
  clearModal as clearModalAction,
  ModalType,
} from '../lib';

export const getUseModal = (modalComponents: any) => {
  return (name: string, initalProps?: any) => {
    const { state, dispatch } = useContext(ModalContext);

    const modal: any = useMemo((): any => {
      let modal: any = undefined;
      Object.entries(modalComponents).forEach(
        (modalComponent: [string, any]) => {
          const [key, value] = modalComponent;
          if (key.toUpperCase() === name.toUpperCase()) modal = value;
        }
      );

      return modal;
    }, [name]);

    // 열려있는지 체크
    const isOpen: boolean = useMemo(() => {
      let isOpen: boolean = false;
      state.forEach((modal: ModalType) => {
        if (modal.name === name.toUpperCase()) isOpen = true;
      });
      return isOpen;
    }, [state, name]);

    // 중복체크
    const isDuplicate = useMemo((): boolean => {
      if (state.length > 0) {
        const findModal = state.find(
          (modal) => modal.name.toUpperCase() === name.toUpperCase()
        );
        if (findModal) return true;
        return false;
      }
      return false;
    }, [state, name]);

    const deleteModal = useCallback((): void => {
      dispatch(deleteModalAction(name.toUpperCase()));
    }, [name, dispatch]);

    const clearModal = useCallback((): void => {
      dispatch(clearModalAction());
    }, [dispatch]);

    const createModal = useCallback(
      (newProps?: any, unshift?: boolean): void => {
        if (isDuplicate) return;

        let props = { onRequestClose: deleteModal };
        if (initalProps) props = { ...props, ...initalProps };
        if (newProps) props = { ...props, ...newProps };

        const newModal = {
          name: name.toUpperCase(),
          component: modal,
          props,
        };

        if (!unshift) {
          dispatch(createModalAction(newModal));
        } else {
          dispatch(createUnshiftModalAction(newModal));
        }
      },
      [name, initalProps, state, dispatch, deleteModal]
    );

    return {
      isOpen,
      modals: state,
      createModal,
      deleteModal,
      clearModal,
    };
  };
};
